module.exports = __webpack_public_path__ + "static/media/college.e368e211.png";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/college.png
// module id = 82
// module chunks = 0